import React, { FC } from "react";
import Svg from "./Svg";
import colors from "../../utils/colorConstants";

interface Props {
  className?: string;
  height: string;
  strokeColor?: string;
  width: string;
}

const Palette: FC<Props> = ({
  className,
  height = "1.5rem",
  strokeColor = colors.lapel,
  width = "1.5rem",
}) => (
  <Svg
    className={className}
    height={height}
    viewBox="0 0 32 32"
    width={width}
    title="envelope icon"
  >
    <path
      fill={strokeColor}
      d="M17.256 2.636l.143.067.138.08 4.245 2.745 1.42.971.731.001c.57 0 1.005.471 1.061 1.046L25 7.67v.984l3.519 2.665c.264.186.434.475.473.792l.008.137v16.12a1.13 1.13 0 01-1.002 1.125l-.123.007H4.125a1.128 1.128 0 01-1.118-1.01L3 28.367V12.25c0-.325.139-.633.368-.84l.104-.082L7 8.691v-1.02c0-.588.398-1.098.947-1.164l.12-.007 1.808-.001 5.728-3.72a1.803 1.803 0 011.653-.143zM15.88 19.843l-.074.053-11.129 8.603h22.51l-10.748-8.63a.5.5 0 00-.559-.026zM28 12.803l-8.688 8.09L28 27.869V12.803zm-24-.071v15.026l8.927-6.901L4 12.732zM23.933 7.5H8.067c-.013 0-.048.038-.062.11L8 7.67v1.521l.001.001L8 9.193v5.827l5.73 5.216 1.45-1.12a1.501 1.501 0 011.746-.122l.125.084 1.473 1.182L24 15.162V7.67c0-.088-.032-.144-.053-.163l-.014-.007zM25 9.908v4.323l2.56-2.384L25 9.908zM7 9.94l-2.516 1.879L7 14.11V9.94zm9.244-6.373l-.099.053-4.434 2.879h9.72l-.202-.139-4.235-2.736a.803.803 0 00-.75-.057z"
    />
  </Svg>
);

export default React.memo(Palette);
